import { render } from "./UpdateNote.vue?vue&type=template&id=3ee2db78&ts=true"
import script from "./UpdateNote.vue?vue&type=script&lang=ts"
export * from "./UpdateNote.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__